module.exports = __webpack_public_path__ + "static/img/56.33767a85.gif";